import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "tw3-flex tw3-min-h-screen tw3-flex-1 tw3-flex-col tw3-items-center tw3-justify-center tw3-gap-4"
}
const _hoisted_2 = {
  key: 2,
  class: "tw3-mx-auto tw3-flex tw3-w-full tw3-max-w-5xl tw3-flex-1 tw3-items-center tw3-justify-center tw3-px-4 tw3-py-12 sm:tw3-px-6"
}
const _hoisted_3 = {
  key: 3,
  class: "tw3-mx-auto tw3-flex tw3-w-full tw3-max-w-5xl tw3-flex-1 tw3-items-center tw3-justify-center tw3-px-4 tw3-py-12 sm:tw3-px-6"
}
const _hoisted_4 = { class: "booking-blurbar tw3-sticky tw3-top-0 tw3-z-20 tw3-border-b tw3-border-surface-200" }
const _hoisted_5 = { class: "tw3-mx-auto tw3-flex tw3-max-w-5xl tw3-items-center tw3-justify-between tw3-gap-3 tw3-px-4 tw3-py-4 sm:tw3-px-6 sm:tw3-py-5" }
const _hoisted_6 = { class: "tw3-flex tw3-min-w-0 tw3-items-center tw3-gap-3" }
const _hoisted_7 = { class: "tw3-min-w-0" }
const _hoisted_8 = { class: "tw3-text-lg tw3-font-bold tw3-leading-tight sm:tw3-text-xl" }
const _hoisted_9 = {
  key: 0,
  class: "tw3-flex tw3-shrink-0 tw3-items-center tw3-gap-2"
}
const _hoisted_10 = {
  key: 0,
  class: "tw3-flex tw3-min-h-80 tw3-flex-1 tw3-flex-col tw3-items-center tw3-justify-center tw3-gap-5 tw3-text-center"
}
const _hoisted_11 = { class: "tw3-mx-auto tw3-mb-10 tw3-flex tw3-w-full tw3-max-w-[15rem] tw3-items-center tw3-justify-center sm:tw3-max-w-sm lg:tw3-max-w-md" }
const _hoisted_12 = { class: "tw3-flex tw3-flex-col tw3-items-center tw3-gap-2" }
const _hoisted_13 = {
  key: 0,
  class: "pi pi-check"
}
const _hoisted_14 = { class: "tw3-space-y-6" }
const _hoisted_15 = {
  key: 0,
  class: "tw3-space-y-6"
}
const _hoisted_16 = { class: "tw3-relative tw3-flex tw3-items-center tw3-justify-center" }
const _hoisted_17 = { class: "tw3-w-full tw3-max-w-md" }
const _hoisted_18 = { class: "tw3-text-lg tw3-font-semibold" }
const _hoisted_19 = { class: "tw3-mt-1 tw3-text-sm tw3-text-surface-500" }
const _hoisted_20 = { class: "tw3-mt-5 tw3-h-2 tw3-overflow-hidden tw3-rounded-full tw3-bg-surface-200" }
const _hoisted_21 = {
  key: 0,
  class: "tw3-space-y-6"
}
const _hoisted_22 = { class: "tw3-mt-6 tw3-grid tw3-gap-4" }
const _hoisted_23 = {
  key: 0,
  class: "tw3-grid tw3-gap-1.5"
}
const _hoisted_24 = {
  key: 1,
  class: "tw3-grid tw3-gap-2"
}
const _hoisted_25 = { class: "tw3-flex tw3-items-center tw3-justify-between tw3-gap-3" }
const _hoisted_26 = { class: "tw3-text-xs tw3-text-surface-500" }
const _hoisted_27 = {
  key: 2,
  class: "tw3-m-0 tw3-rounded-lg tw3-bg-red-50 tw3-p-3 tw3-text-sm tw3-font-medium tw3-text-red-700"
}
const _hoisted_28 = {
  key: 1,
  class: "tw3-space-y-6"
}
const _hoisted_29 = {
  key: 1,
  class: "tw3-space-y-4"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 2,
  class: "tw3-space-y-6"
}
const _hoisted_32 = { class: "tw3-text-center" }
const _hoisted_33 = { class: "tw3-mx-auto tw3-mt-2 tw3-max-w-md tw3-text-sm tw3-text-surface-500" }
const _hoisted_34 = { class: "tw3-grid tw3-gap-4 md:tw3-grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] md:tw3-items-stretch" }
const _hoisted_35 = { class: "tw3-grid tw3-gap-6 lg:tw3-grid-cols-[minmax(0,1fr)_20rem] lg:tw3-items-start" }
const _hoisted_36 = { class: "tw3-space-y-6" }
const _hoisted_37 = { class: "tw3-grid tw3-items-start tw3-gap-4 md:tw3-grid-cols-2" }
const _hoisted_38 = { class: "tw3-grid tw3-gap-1.5 md:tw3-col-span-2" }
const _hoisted_39 = { class: "tw3-flex tw3-gap-2" }
const _hoisted_40 = { class: "tw3-grid tw3-gap-1.5 md:tw3-col-span-2" }
const _hoisted_41 = { class: "tw3-grid tw3-gap-4" }
const _hoisted_42 = { class: "tw3-grid tw3-gap-1.5" }
const _hoisted_43 = { class: "tw3-grid tw3-gap-1.5" }
const _hoisted_44 = { class: "tw3-grid tw3-gap-1.5" }
const _hoisted_45 = {
  key: 1,
  class: "tw3-m-0 tw3-text-sm tw3-text-surface-500"
}
const _hoisted_46 = { class: "tw3-flex tw3-items-start tw3-gap-3" }
const _hoisted_47 = { class: "lg:tw3-sticky lg:tw3-top-24" }
const _hoisted_48 = { class: "tw3-grid tw3-gap-6 lg:tw3-grid-cols-[minmax(0,1fr)_20rem] lg:tw3-items-start" }
const _hoisted_49 = { class: "tw3-relative tw3-flex tw3-items-center tw3-justify-center" }
const _hoisted_50 = { class: "tw3-space-y-6" }
const _hoisted_51 = { class: "tw3-m-0 tw3-max-w-md tw3-text-sm tw3-text-red-600" }
const _hoisted_52 = { class: "tw3-m-0 tw3-grid tw3-gap-3 [&>div:last-child]:tw3-border-0 [&>div:last-child]:tw3-pb-0" }
const _hoisted_53 = { class: "tw3-flex tw3-justify-between tw3-gap-4 tw3-border-b tw3-border-surface-100 tw3-pb-3" }
const _hoisted_54 = { class: "tw3-m-0 tw3-text-right tw3-text-sm tw3-font-medium" }
const _hoisted_55 = { class: "tw3-flex tw3-justify-between tw3-gap-4 tw3-border-b tw3-border-surface-100 tw3-pb-3" }
const _hoisted_56 = { class: "tw3-m-0 tw3-text-right tw3-text-sm tw3-font-medium" }
const _hoisted_57 = { class: "tw3-flex tw3-justify-between tw3-gap-4 tw3-border-b tw3-border-surface-100 tw3-pb-3" }
const _hoisted_58 = { class: "tw3-m-0 tw3-text-right tw3-text-sm tw3-font-medium" }
const _hoisted_59 = { class: "tw3-flex tw3-justify-between tw3-gap-4 tw3-border-b tw3-border-surface-100 tw3-pb-3" }
const _hoisted_60 = { class: "tw3-m-0 tw3-text-right tw3-text-sm tw3-font-medium" }
const _hoisted_61 = { class: "tw3-flex tw3-justify-between tw3-gap-4 tw3-border-b tw3-border-surface-100 tw3-pb-3" }
const _hoisted_62 = { class: "tw3-m-0 tw3-text-right tw3-text-sm tw3-font-medium" }
const _hoisted_63 = { class: "tw3-flex tw3-justify-between tw3-gap-4 tw3-border-b tw3-border-surface-100 tw3-pb-3" }
const _hoisted_64 = { class: "tw3-m-0 tw3-text-right tw3-text-sm tw3-font-medium" }
const _hoisted_65 = {
  key: 0,
  class: "tw3-flex tw3-justify-between tw3-gap-4 tw3-border-b tw3-border-surface-100 tw3-pb-3"
}
const _hoisted_66 = { class: "tw3-text-sm tw3-text-surface-500" }
const _hoisted_67 = { class: "tw3-m-0 tw3-text-right tw3-text-sm tw3-font-semibold tw3-text-primary-600" }
const _hoisted_68 = { class: "lg:tw3-sticky lg:tw3-top-24" }
const _hoisted_69 = {
  key: 0,
  class: "booking-blurbar tw3-fixed tw3-inset-x-0 tw3-bottom-0 tw3-z-20 tw3-border-t tw3-border-surface-200"
}
const _hoisted_70 = { class: "tw3-mx-auto tw3-flex tw3-max-w-5xl tw3-items-center tw3-justify-between tw3-gap-3 tw3-px-6 tw3-py-3" }
const _hoisted_71 = {
  key: 0,
  class: "tw3-hidden tw3-items-center tw3-gap-5 sm:tw3-flex"
}
const _hoisted_72 = { class: "tw3-flex tw3-items-baseline tw3-gap-2" }
const _hoisted_73 = { class: "tw3-text-base tw3-font-semibold tw3-text-surface-700" }
const _hoisted_74 = {
  key: 0,
  class: "tw3-flex tw3-items-baseline tw3-gap-2"
}
const _hoisted_75 = { class: "tw3-text-lg tw3-font-bold tw3-text-primary-600" }

import { loadStripe } from '@stripe/stripe-js';
import { toTypedSchema } from '@vee-validate/zod';
import Checkbox from 'primevue/checkbox';
import DatePicker from 'primevue/datepicker';
import InputMask from 'primevue/inputmask';
import InputOtp from 'primevue/inputotp';
import InputText from 'primevue/inputtext';
import ProgressSpinner from 'primevue/progressspinner';
import Select from 'primevue/select';
import { useForm } from 'vee-validate';
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import * as zod from 'zod';

import { Address } from '@/entities/address/lib/types';
import { useBookingQuoteStore } from '@/entities/quickQuote/lib/booking-store';
import InputAddress from '@/features/address/InputAddress.vue';
import PlateDecoder from '@/features/plateDecoder/PlateDecoder.vue';
import VinDecoder from '@/features/vinDecoder/VinDecoder.vue';
import { useMessages } from '@/shared/composables';
import { addDays } from '@/shared/helpers';
import { formatMoney } from '@/shared/helpers/formatters';
import { InputTextWithError } from '@/shared/ui';
import { LicensePlate } from '@/widgets/quickQuoteDialog/model/types';

import {
	confirmPhone,
	createEstimate,
	createEstimateVehicles,
	createPaymentIntent,
	createQuote,
	getEstimateErrorCode,
	getQuickQuoteSettings
} from './api';
import {
	dateKey,
	federalHolidayDates,
	Holiday,
	holidayByDate,
	holidayColor,
	weekdayName
} from './lib/holidays';
import {
	bookingThemeVars,
	DEFAULT_BOOKING_COLOR,
	isBookingColor
} from './lib/theme';
import BookingButton from './ui/BookingButton.vue';
import BookingCard from './ui/BookingCard.vue';
import BookingCardHeader from './ui/BookingCardHeader.vue';
import BookingErrorCard from './ui/BookingErrorCard.vue';
import BookingField from './ui/BookingField.vue';
import BookingItemPricing from './ui/BookingItemPricing.vue';
import BookingQuoteSummary from './ui/BookingQuoteSummary.vue';
import BookingVehicleCard from './ui/BookingVehicleCard.vue';

import type {
	CreateQuotePayload,
	EstimateVehicle
} from '@/entities/quickQuote/lib/booking-api.types';
import type {
	Stripe,
	StripeElements,
	StripePaymentElement
} from '@stripe/stripe-js';

type BookingStep = 1 | 2 | 3;
type PhoneVerificationStage = 'vehicle' | 'phone' | 'code';
type VehicleEstimateRequest =
	| { vin: string }
	| { plate: string; state: string };

enum VehicleSearchError {
	GLASS_UNAVAILABLE = 'glass-unavailable',
	SERVICE_UNAVAILABLE = 'service-unavailable',
	VEHICLE_NOT_FOUND = 'vehicle-not-found'
}

const STRIPE_PUBLISHABLE_KEY =
	'pk_live_51OMbKuJjPzVNKuc0OnesvqgcZqKK4aFCFyaa2lbobspne1yCbB0DJtU5F18cW6ZFP3iqLI4aKrZXrzfgpq6umVil004p2UJhR5';

const settingsRestartError = 'Please start over before continuing.';


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingPage',
  props: {
    apiKey: {},
    closable: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const GLASS_UNAVAILABLE_ERROR_CODES = new Set([
	'WINDSHIELD_NOT_FOUND',
	'NAGS_PART_NOT_FOUND',
	'VENDOR_OFFER_NOT_FOUND'
]);

const steps: { value: BookingStep; label: string; icon: string }[] = [
	{ value: 1, label: 'Vehicle', icon: 'pi pi-car' },
	{ value: 2, label: 'Details', icon: 'pi pi-user' },
	{ value: 3, label: 'Confirm', icon: 'pi pi-calendar' }
];

const bookingStore = useBookingQuoteStore();
const toastMessages = useMessages();

const activeStep = ref<BookingStep>(1);
const settingsLoading = ref(true);
const settingsError = ref(false);
const isLoading = ref(false);
const isSubmitting = ref(false);
const submitted = ref(false);
const vehicleSearchError = ref<VehicleSearchError>();
const detailsValidationAttempted = ref(false);
const phoneVerificationStage = ref<PhoneVerificationStage>('vehicle');
const verificationVehicleRequest = ref<VehicleEstimateRequest>();
const verificationPhone = ref('');
const verificationCode = ref('');
const verificationError = ref('');
const phoneConfirmationLoading = ref(false);
const verifiedPhoneNumber = ref('');
const storeConsumerData = ref(false);
const estimateConsumerExists = ref(false);

const loadingMessageIndex = ref(0);
const loadingProgress = ref(8);
let loadingMessageInterval: ReturnType<typeof setInterval> | undefined;
let loadingProgressInterval: ReturnType<typeof setInterval> | undefined;
let abortCon: AbortController | undefined;

// --- Scheduling (last screen) ---
const scheduledDate = ref<Date | null>(null);
const notes = ref('');
const installTimeSpanId = ref<number | null>(null);

const paymentElementContainer = ref<HTMLElement | null>(null);
const paymentSetupLoading = ref(false);
const paymentSetupError = ref<string | null>(null);
const stripeLoadError = ref(false);

let stripeConnection: Stripe | null = null;
let stripeConnectionAccountId: string | null = null;
let stripeElements: StripeElements | null = null;
let stripePaymentElement: StripePaymentElement | null = null;
let paymentIntentAmount: number | null = null;

// --- Details form ---
// Fields + validation mirror ContactInfoPhones / ContactInfoEmails /
// ContactInfoAddresses, but as a single instance each. First name is required.
const { t } = useI18n();

const detailsSchema = toTypedSchema(
	zod.object({
		first_name: zod.string({ message: t('required') }).min(1, t('required')),
		last_name: zod.string().optional(),
		phone: zod.object({
			number: zod
				.string({ message: t('required') })
				.min(14, t('errorNumber'))
				.max(14, t('errorNumber')),
			extension: zod.string().nullish()
		}),
		email: zod.string({ message: t('required') }).email(),
		address: zod.object({
			address: zod.string({ message: t('invalidAddress') }),
			city: zod.string().nullish(),
			extra: zod.string().nullish(),
			full_address: zod.string({ message: t('required') }),
			google_place_id: zod.string({ message: t('invalidAddress') }),
			lat: zod.number({ message: t('invalidAddress') }),
			lng: zod.number({ message: t('invalidAddress') }),
			po_box: zod.number().nullish(),
			state: zod.string().nullish(),
			unit: zod.string().nullish(),
			zip: zod.string().nullish()
		})
	})
);

const {
	defineField,
	errors,
	validate: validateDetailsForm,
	resetForm: resetDetailsForm,
	setValues: setDetailsValues,
	values: detailsValues
} = useForm({
	validationSchema: detailsSchema,
	initialValues: {
		first_name: '',
		last_name: '',
		phone: { number: '', extension: '' },
		email: '',
		address: {}
	}
});

const [firstName] = defineField('first_name');
const [lastName] = defineField('last_name');
const [phoneNumber] = defineField('phone.number');
const [phoneExtension] = defineField('phone.extension');
const [email] = defineField('email');
const [address] = defineField('address');

const getAddressError = () => {
	const addressFields = [
		'address.full_address',
		'address.google_place_id',
		'address.lat',
		'address.lng',
		'address.address'
	];
	for (const field of addressFields) {
		const message = errors.value[field as keyof typeof errors.value];
		if (message) return message;
	}
	return errors.value.address;
};

const hasCoordinates = (value: Partial<Address> | null | undefined) =>
	Boolean(
		value?.lat &&
			value?.lng &&
			Number.isFinite(Number(value.lat)) &&
			Number.isFinite(Number(value.lng))
	);

const getDistanceInMiles = (
	first: Pick<Address, 'lat' | 'lng'>,
	second: Pick<Address, 'lat' | 'lng'>
) => {
	const earthRadiusInMiles = 3958.8;
	const toRadians = (value: number) => (value * Math.PI) / 180;

	const firstLat = Number(first.lat);
	const secondLat = Number(second.lat);
	const deltaLat = toRadians(secondLat - firstLat);
	const deltaLng = toRadians(Number(second.lng) - Number(first.lng));

	const haversine =
		Math.sin(deltaLat / 2) ** 2 +
		Math.cos(toRadians(firstLat)) *
			Math.cos(toRadians(secondLat)) *
			Math.sin(deltaLng / 2) ** 2;

	return (
		2 *
		earthRadiusInMiles *
		Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine))
	);
};

const serviceRadiusError = computed(() => {
	if (
		!(
			bookingStore.requiredMobileFeeOption ||
			bookingStore.selectedExtraOptionKeys.includes('mobileFee')
		) ||
		!bookingStore.radiusIsTurned ||
		bookingStore.radiusInMiles == null
	)
		return undefined;
	if (!hasCoordinates(bookingStore.shopAddress)) return undefined;

	const consumerAddress = address.value as Partial<Address> | null | undefined;
	if (!consumerAddress?.full_address && !consumerAddress?.address)
		return undefined;

	if (!hasCoordinates(consumerAddress)) {
		return 'Customer address coordinates are required for mobile service';
	}

	const radiusInMiles = Number(bookingStore.radiusInMiles);
	if (!Number.isFinite(radiusInMiles)) return undefined;

	const distanceInMiles = getDistanceInMiles(
		bookingStore.shopAddress as Pick<Address, 'lat' | 'lng'>,
		consumerAddress as Pick<Address, 'lat' | 'lng'>
	);

	if (distanceInMiles > radiusInMiles) {
		return `Customer address is outside the ${bookingStore.radiusInMiles} mile mobile service radius`;
	}

	return undefined;
});

const addressError = computed(
	() =>
		serviceRadiusError.value ||
		(detailsValidationAttempted.value ? getAddressError() : undefined)
);

const loadingMessages = [
	'Reading vehicle data...',
	'Matching the glass options...',
	'Checking supplier availability...',
	'Comparing available prices...',
	'Building your booking estimate...'
];
const loadingMessage = computed(
	() => bookingStore.currentStep || loadingMessages[loadingMessageIndex.value]
);
const estimateLoadingNotice = ref('');
const loadingDescription = computed(
	() =>
		estimateLoadingNotice.value ||
		'Supplier searches can take up to 30 seconds. We are still working'
);

const themeStyle = computed(() => {
	const color = bookingStore.bookingColor;
	return bookingThemeVars(
		isBookingColor(color) ? color : DEFAULT_BOOKING_COLOR
	);
});

const currentStepIndex = computed(() =>
	steps.findIndex(step => step.value === activeStep.value)
);

const vehicles = computed(() => bookingStore.vehicles);

const pricingReady = computed(
	() =>
		!isLoading.value &&
		bookingStore.selectedVehicle &&
		bookingStore.quoteTotal !== null
);
const canContinueFromVehicle = computed(() => Boolean(pricingReady.value));
const canContinueFromDetails = computed(() => !serviceRadiusError.value);
const normalizedVerificationPhone = computed(() =>
	verificationPhone.value.replace(/\D/g, '')
);
const normalizedVerificationCode = computed(() =>
	verificationCode.value.replace(/\D/g, '').slice(0, 6)
);
const canConfirmPhone = computed(
	() =>
		normalizedVerificationPhone.value.length >= 10 &&
		!phoneConfirmationLoading.value
);
const canVerifyCode = computed(
	() => normalizedVerificationCode.value.length === 6 && !isLoading.value
);

const quoteTotal = computed(() => bookingStore.quoteTotal);
const hasQuote = computed(
	() => Boolean(bookingStore.selectedVehicle) && quoteTotal.value !== null
);
const showVehicleSearchResult = computed(
	() => bookingStore.vehicleSearchComplete || Boolean(vehicleSearchError.value)
);
const showPhoneVerification = computed(
	() =>
		bookingStore.phoneVerificationRequired &&
		phoneVerificationStage.value !== 'vehicle' &&
		Boolean(bookingStore.selectedVehicle) &&
		!isLoading.value &&
		!bookingStore.estimateId
);
const showStoreConsumerDataConsent = computed(
	() =>
		bookingStore.phoneVerificationRequired &&
		Boolean(verifiedPhoneNumber.value) &&
		!estimateConsumerExists.value
);
const vehicleSearchContent = computed(() => {
	switch (vehicleSearchError.value) {
		case VehicleSearchError.GLASS_UNAVAILABLE:
			return {
				title: 'Glass quote unavailable',
				description:
					"We found your vehicle, but couldn't find an available glass option online",
				hint: `Contact ${bookingStore.shopName} directly and they can help with your quote`
			};
		case VehicleSearchError.SERVICE_UNAVAILABLE:
			return {
				title: "We couldn't complete your search",
				description:
					'The quote service is unavailable right now. Please try again in a few moments',
				hint: `If the issue continues, contact ${bookingStore.shopName} for help`
			};
		default:
			return {
				title: 'No matching vehicle found',
				description:
					"We couldn't match that VIN or plate to a vehicle. Check the details and search again",
				hint: 'For a VIN, enter all 17 characters. For a plate, confirm the number and state are correct'
			};
	}
});
const paymentRequired = computed(() => bookingStore.paymentRequired);

const prepaymentAmountCents = computed(
	() => bookingStore.prepaymentAmountCents
);
const paymentStepLoading = computed(
	() => paymentRequired.value && paymentSetupLoading.value
);

const selectedVehicle = computed(() => bookingStore.selectedVehicle);
const vehicleLabel = computed(() => {
	const vehicle = bookingStore.selectedVehicle;
	if (!vehicle) return undefined;
	return [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
});

const installTimeSpans = computed(() => bookingStore.installTimeSpans);
const timeSpanOptions = computed(() =>
	installTimeSpans.value.map(span => ({
		id: span.id,
		label: formatTimeSpan(span.name, span.time_start, span.time_end)
	}))
);

const disabledDays = computed(() => bookingStore.excludedWeekdays ?? []);

const disallowedDatesAfterToday = computed(() =>
	Array.from(
		{ length: bookingStore.disallowForDaysAfterToday + 1 },
		(_, index) => addDays(new Date(), index)
	)
);

const disabledDates = computed(() => {
	const holidays = bookingStore.excludeHolidays
		? federalHolidayDates.map(key => {
				const [year, month, day] = key.split('-').map(Number);
				return new Date(year, month - 1, day);
			})
		: [];

	return [...holidays, ...disallowedDatesAfterToday.value];
});

const holidayForCell = (cell: { year: number; month: number; day: number }) =>
	holidayByDate.get(dateKey(cell.year, cell.month + 1, cell.day));

const holidayCellStyle = (holiday: Holiday) => ({
	position: 'relative' as const,
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '100%',
	fontWeight: '700',
	color: holidayColor(holiday),
	pointerEvents: 'auto' as const,
	cursor: 'help'
});

const holidayDotStyle = (holiday: Holiday) => ({
	position: 'absolute' as const,
	bottom: '3px',
	left: '50%',
	transform: 'translateX(-50%)',
	width: '5px',
	height: '5px',
	borderRadius: '9999px',
	backgroundColor: holidayColor(holiday)
});

const closedWeekday = (cell: { year: number; month: number; day: number }) => {
	if (!disabledDays.value.length) return undefined;
	const weekday = new Date(cell.year, cell.month, cell.day).getDay();
	return disabledDays.value.includes(weekday) ? weekday : undefined;
};

const closedWeekdayLabel = (weekday: number) =>
	`We're closed on ${weekdayName(weekday)}s`;

const closedCellStyle = {
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '100%',
	pointerEvents: 'auto' as const,
	cursor: 'help'
};

// --- Stepper visual state ---
const nodeClass = (index: number) => {
	if (index < currentStepIndex.value) {
		return 'tw3-border-primary-500 tw3-bg-primary-500 tw3-text-white';
	}
	if (index === currentStepIndex.value) {
		return 'tw3-border-primary-500 tw3-bg-primary-50 tw3-text-primary-600 tw3-ring-4 tw3-ring-primary-100';
	}
	return 'tw3-border-surface-200 tw3-bg-surface-0 tw3-text-surface-400';
};
const labelClass = (index: number) => {
	if (index === currentStepIndex.value) return 'tw3-text-surface-900';
	if (index < currentStepIndex.value) return 'tw3-text-surface-700';
	return 'tw3-text-surface-400';
};

const formatTimeSpan = (
	name: string | null,
	start: string | null,
	end: string | null
) => {
	const formatTime = (value: string | null) => {
		if (!value) return null;

		const [hoursRaw, minutesRaw = '00'] = value.split(':');
		const hours = Number(hoursRaw);
		const minutes = Number(minutesRaw);

		if (Number.isNaN(hours) || Number.isNaN(minutes)) return value.slice(0, 5);

		const suffix = hours >= 12 ? 'PM' : 'AM';
		const displayHours = hours % 12 || 12;
		const displayMinutes = String(minutes).padStart(2, '0');

		return `${displayHours}:${displayMinutes} ${suffix}`;
	};

	const window = [formatTime(start), formatTime(end)]
		.filter(Boolean)
		.join(' - ');

	if (name && window) return `${name} (${window})`;
	return name || window || 'Time window';
};

const stopLoadingAnimation = () => {
	if (loadingMessageInterval) clearInterval(loadingMessageInterval);
	if (loadingProgressInterval) clearInterval(loadingProgressInterval);

	loadingMessageInterval = undefined;
	loadingProgressInterval = undefined;
};

const isPhoneVerificationNotRequiredError = (errorCode: string | undefined) =>
	errorCode === 'PHONE_VERIFICATION_NOT_REQUIRED';

const startLoadingAnimation = () => {
	stopLoadingAnimation();
	loadingMessageIndex.value = 0;
	loadingProgress.value = 8;

	loadingMessageInterval = setInterval(() => {
		loadingMessageIndex.value =
			(loadingMessageIndex.value + 1) % loadingMessages.length;
	}, 3500);

	loadingProgressInterval = setInterval(() => {
		loadingProgress.value =
			loadingProgress.value < 78
				? loadingProgress.value + 6
				: Math.min(92, loadingProgress.value + 1);
	}, 900);
};

const cancelEstimateRequest = () => {
	abortCon?.abort();
	abortCon = undefined;
	bookingStore.currentStep = undefined;
	estimateLoadingNotice.value = '';
	isLoading.value = false;
};

const resetPhoneVerification = () => {
	phoneVerificationStage.value = 'vehicle';
	verificationVehicleRequest.value = undefined;
	verificationPhone.value = '';
	verificationCode.value = '';
	verificationError.value = '';
	phoneConfirmationLoading.value = false;
	verifiedPhoneNumber.value = '';
	estimateConsumerExists.value = false;
	estimateLoadingNotice.value = '';
};

const showSettingsReloadRequiredError = async () => {
	verificationError.value = settingsRestartError;
	phoneVerificationStage.value = 'phone';
	await loadSettings();
};

const formatPhoneForDetails = (value: string) => {
	const digits = value.replace(/\D/g, '').slice(0, 10);
	if (digits.length !== 10) return value;
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

const applyEstimateConsumer = (consumer: unknown) => {
	estimateConsumerExists.value = Boolean(
		consumer && typeof consumer === 'object'
	);
	if (!estimateConsumerExists.value) return;

	const data = consumer as Record<string, any>;
	const phoneValue =
		typeof data.phone_number === 'string'
			? data.phone_number.replace('+1', '')
			: typeof data.phone?.number === 'string'
				? data.phone.number.replace('+1', '')
				: '';

	setDetailsValues({
		first_name: typeof data.first_name === 'string' ? data.first_name : '',
		last_name: typeof data.last_name === 'string' ? data.last_name : '',
		phone: {
			number: formatPhoneForDetails(phoneValue || verifiedPhoneNumber.value),
			extension:
				typeof data.phone?.extension === 'string' ? data.phone.extension : ''
		},
		email: typeof data.email === 'string' ? data.email : '',
		address:
			data.address && typeof data.address === 'object'
				? (data.address as Record<string, unknown>)
				: {}
	});
};

const runEstimate = async (
	req:
		| { vin: string; phone?: string; phone_verification_code?: string }
		| {
				plate: string;
				state: string;
				phone?: string;
				phone_verification_code?: string;
		  },
	options: { notice?: string } = {}
) => {
	abortCon?.abort();
	const controller = new AbortController();
	abortCon = controller;
	vehicleSearchError.value = undefined;
	estimateLoadingNotice.value = options.notice ?? '';
	isLoading.value = true;

	try {
		bookingStore.currentStep = 'Building your booking estimate...';
		const data = await createEstimate(props.apiKey, req, controller.signal);
		const selectedVehicleKey = bookingStore.selectedVehicleKey;

		bookingStore.applyEstimate(data);
		if (
			selectedVehicleKey &&
			data.vehicles.some(vehicle => vehicle.key === selectedVehicleKey)
		) {
			bookingStore.selectedVehicleKey = selectedVehicleKey;
		}
		if ('phone' in req && req.phone) {
			verifiedPhoneNumber.value = req.phone;
			phoneNumber.value = formatPhoneForDetails(req.phone);
		}
		applyEstimateConsumer(data.consumer);
		if (estimateConsumerExists.value) storeConsumerData.value = false;

		if (!data.optimal?.length) {
			toastMessages.showWarning(
				'We could not find pricing for this glass. Please try again later or contact the shop directly.'
			);
		}
	} catch (error) {
		if (controller.signal.aborted) return;

		const errorCode = getEstimateErrorCode(error);
		if (errorCode === 'INVALID_PHONE_VERIFICATION_CODE') {
			verificationError.value = 'The verification code is incorrect.';
			phoneVerificationStage.value = 'code';
		} else if (errorCode === 'PHONE_VERIFICATION_REQUIRED_FOR_ESTIMATE') {
			await showSettingsReloadRequiredError();
		} else {
			bookingStore.resetEstimate();
			vehicleSearchError.value =
				errorCode === 'VIN_NOT_FOUND'
					? VehicleSearchError.VEHICLE_NOT_FOUND
					: errorCode && GLASS_UNAVAILABLE_ERROR_CODES.has(errorCode)
						? VehicleSearchError.GLASS_UNAVAILABLE
						: VehicleSearchError.SERVICE_UNAVAILABLE;
		}
	} finally {
		if (abortCon === controller) {
			bookingStore.currentStep = undefined;
			isLoading.value = false;
			abortCon = undefined;
		}
	}
};

const runVehicleSearch = async (req: VehicleEstimateRequest) => {
	abortCon?.abort();
	const controller = new AbortController();
	abortCon = controller;
	vehicleSearchError.value = undefined;
	estimateLoadingNotice.value = '';
	isLoading.value = true;

	try {
		bookingStore.currentStep = 'Finding your vehicle...';
		const data = await createEstimateVehicles(
			props.apiKey,
			req,
			controller.signal
		);

		bookingStore.applyEstimateVehicles(data.vehicles);
		verificationVehicleRequest.value = req;
		verificationPhone.value = '';
		verificationCode.value = '';
		verificationError.value = '';
		phoneVerificationStage.value = bookingStore.selectedVehicle
			? 'phone'
			: 'vehicle';
	} catch (error) {
		if (controller.signal.aborted) return;

		bookingStore.resetEstimate();
		const errorCode = getEstimateErrorCode(error);
		if (isPhoneVerificationNotRequiredError(errorCode)) {
			await loadSettings();
			await runEstimate(req);
			return;
		}

		vehicleSearchError.value =
			errorCode === 'VIN_NOT_FOUND'
				? VehicleSearchError.VEHICLE_NOT_FOUND
				: errorCode && GLASS_UNAVAILABLE_ERROR_CODES.has(errorCode)
					? VehicleSearchError.GLASS_UNAVAILABLE
					: VehicleSearchError.SERVICE_UNAVAILABLE;
	} finally {
		if (abortCon === controller) {
			bookingStore.currentStep = undefined;
			isLoading.value = false;
			abortCon = undefined;
		}
	}
};

const onVinSubmit = (vin: string) => {
	if (!bookingStore.phoneVerificationRequired) return runEstimate({ vin });

	bookingStore.resetEstimate();
	return runVehicleSearch({ vin });
};

const submitVerificationPhone = async () => {
	if (!canConfirmPhone.value) return;

	phoneConfirmationLoading.value = true;
	verificationError.value = '';

	try {
		await confirmPhone(props.apiKey, {
			phone: normalizedVerificationPhone.value
		});
		verificationPhone.value = normalizedVerificationPhone.value;
		verificationCode.value = '';
		phoneVerificationStage.value = 'code';
	} catch (error) {
		const errorCode = getEstimateErrorCode(error);
		if (isPhoneVerificationNotRequiredError(errorCode)) {
			await loadSettings();
			if (verificationVehicleRequest.value) {
				await runEstimate(verificationVehicleRequest.value, {
					notice:
						'Your shop no longer requires phone verification. We are building your estimate now.'
				});
			} else {
				await showSettingsReloadRequiredError();
			}
		} else {
			verificationError.value =
				'We could not send the verification code. Please try again.';
		}
	} finally {
		phoneConfirmationLoading.value = false;
	}
};

const submitVerificationCode = async () => {
	if (!canVerifyCode.value || !verificationVehicleRequest.value) return;

	verificationError.value = '';
	estimateLoadingNotice.value = '';
	bookingStore.currentStep = 'Building your booking estimate...';
	isLoading.value = true;
	await nextTick();

	await runEstimate({
		...verificationVehicleRequest.value,
		phone: normalizedVerificationPhone.value,
		phone_verification_code: normalizedVerificationCode.value
	});
};

const onPlateSubmit = async (plate: LicensePlate) => {
	if (bookingStore.phoneVerificationRequired) {
		bookingStore.resetEstimate();
		bookingStore.vehiclePlate = plate;
		return runVehicleSearch({
			plate: plate.number,
			state: plate.state
		});
	}

	bookingStore.currentStep = 'Identifying vehicle...';
	bookingStore.vehiclePlate = plate;
	await runEstimate({ plate: plate.number, state: plate.state });
};

const chooseVehicle = (vehicle: EstimateVehicle) => {
	bookingStore.selectVehicle(vehicle);
	if (bookingStore.phoneVerificationRequired && !bookingStore.estimateId) {
		phoneVerificationStage.value = 'phone';
		verificationError.value = '';
	}
};

const startOver = () => {
	cancelEstimateRequest();
	activeStep.value = 1;
	submitted.value = false;
	vehicleSearchError.value = undefined;
	resetPhoneVerification();
	storeConsumerData.value = false;
	estimateLoadingNotice.value = '';
	bookingStore.startOver();
	resetDetailsForm();
	scheduledDate.value = null;
	notes.value = '';
	installTimeSpanId.value = null;
	resetPayment();
};

const goNext = () => {
	const nextStep = steps[currentStepIndex.value + 1];
	if (nextStep) activeStep.value = nextStep.value;
};

const canGoBack = computed(() => {
	if (submitted.value) return false;
	if (activeStep.value > 1) return true;
	if (phoneVerificationStage.value !== 'vehicle') return true;
	return vehicles.value.length > 1 && Boolean(bookingStore.selectedVehicle);
});

const goBack = () => {
	if (activeStep.value === 1 && phoneVerificationStage.value === 'code') {
		phoneVerificationStage.value = 'phone';
		verificationError.value = '';
		return;
	}
	if (activeStep.value === 1 && phoneVerificationStage.value === 'phone') {
		resetPhoneVerification();
		return;
	}

	if (activeStep.value === 1) {
		if (vehicles.value.length > 1 && bookingStore.selectedVehicle) {
			bookingStore.selectedVehicleKey = undefined;
		}
		return;
	}

	const previousStep = steps[currentStepIndex.value - 1];
	if (previousStep) activeStep.value = previousStep.value;
};

const continueFromDetails = async () => {
	detailsValidationAttempted.value = true;
	const { valid } = await validateDetailsForm();
	if (!valid || serviceRadiusError.value) {
		activeStep.value = 2;
		return;
	}

	goNext();
};

const ADDRESS_KEYS: (keyof Address)[] = [
	'address',
	'city',
	'extra',
	'full_address',
	'google_place_id',
	'lat',
	'lng',
	'po_box',
	'state',
	'unit',
	'zip'
];

const buildAddressPayload = (
	value: Record<string, unknown> | null | undefined
) => {
	if (!value?.full_address && !value?.address) return null;

	const payload: Record<string, unknown> = {};
	for (const key of ADDRESS_KEYS) {
		const fieldValue = value[key];
		if (fieldValue !== undefined) payload[key] = fieldValue;
	}
	return payload as Partial<Address>;
};

const toDateString = (date: Date) => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

const rgbChannels = (channels: string, fallback: string) => {
	const value = channels.trim();
	return value ? `rgb(${value.split(/\s+/).join(', ')})` : fallback;
};

const resolveThemeColor = (variable: string, fallback: string) => {
	const themed = themeStyle.value[variable];
	if (themed) {
		return rgbChannels(themed, fallback);
	}
	const el = paymentElementContainer.value ?? document.documentElement;
	return rgbChannels(getComputedStyle(el).getPropertyValue(variable), fallback);
};

const teardownPaymentElement = () => {
	stripePaymentElement?.destroy();
	stripePaymentElement = null;
	stripeElements = null;
};

const resetPayment = () => {
	teardownPaymentElement();
	paymentIntentAmount = null;
	stripeLoadError.value = false;
	paymentSetupError.value = null;
};

const setupPayment = async () => {
	const amount = prepaymentAmountCents.value;
	if (
		paymentSetupLoading.value ||
		!paymentRequired.value ||
		!bookingStore.estimateId ||
		amount === null
	) {
		return;
	}

	// The mounted form still matches the current prepayment total — nothing to redo.
	if (
		stripePaymentElement &&
		paymentIntentAmount === amount &&
		!stripeLoadError.value &&
		!paymentSetupError.value
	) {
		return;
	}

	paymentSetupLoading.value = true;
	paymentSetupError.value = null;
	stripeLoadError.value = false;
	teardownPaymentElement();

	try {
		const intent = await createPaymentIntent(props.apiKey, {
			estimateId: bookingStore.estimateId,
			amount
		});
		paymentIntentAmount = amount;

		const accountId = intent.stripeAccountId ?? null;
		if (!stripeConnection || stripeConnectionAccountId !== accountId) {
			stripeConnection = await loadStripe(
				STRIPE_PUBLISHABLE_KEY,
				accountId ? { stripeAccount: accountId } : undefined
			);
			stripeConnectionAccountId = accountId;
		}

		if (!stripeConnection) {
			stripeLoadError.value = true;
			return;
		}

		stripeElements = stripeConnection.elements({
			clientSecret: intent.clientSecret,
			appearance: {
				theme: 'stripe',
				variables: {
					colorPrimary: resolveThemeColor('--primary-600', 'rgb(5, 150, 105)'),
					colorText: resolveThemeColor('--surface-900', 'rgb(15, 23, 42)'),
					colorTextSecondary: resolveThemeColor(
						'--surface-500',
						'rgb(100, 116, 139)'
					)
				},
				rules: {
					'.AccordionItem': { borderRadius: '16px' },
					'.Input': { borderRadius: '8px' }
				}
			}
		});

		stripePaymentElement = stripeElements.create('payment');
		stripePaymentElement.on('loaderror', () => {
			stripeLoadError.value = true;
		});

		paymentSetupLoading.value = false;
		await nextTick();
		if (paymentElementContainer.value) {
			stripePaymentElement.mount(paymentElementContainer.value);
		}
	} catch (error) {
		paymentIntentAmount = null;
		paymentSetupError.value =
			(error as { response?: { data?: { message?: string } } })?.response?.data
				?.message ??
			(error as Error)?.message ??
			'We could not initialize the payment form.';
	} finally {
		paymentSetupLoading.value = false;
	}
};

const authorizePayment = async (): Promise<string | null> => {
	if (!stripeConnection || !stripeElements) {
		toastMessages.showError('The payment form is not ready yet.');
		return null;
	}

	try {
		const { error, paymentIntent } = await stripeConnection.confirmPayment({
			elements: stripeElements,
			confirmParams: { return_url: window.location.href },
			redirect: 'if_required'
		});

		if (error || !paymentIntent) {
			toastMessages.showError(error?.message || 'Payment failed');
			return null;
		}

		return paymentIntent.id;
	} catch (error) {
		toastMessages.showError((error as Error)?.message || 'Payment failed');
		return null;
	}
};

watch([activeStep, prepaymentAmountCents], ([step]) => {
	if (step === 3 && paymentRequired.value) setupPayment();
});

const submitBooking = async () => {
	if (!bookingStore.estimateId || !bookingStore.selectedVehicleKey) {
		return;
	}

	detailsValidationAttempted.value = true;
	const { valid } = await validateDetailsForm();
	if (!valid || serviceRadiusError.value) {
		activeStep.value = 2;
		return;
	}

	isSubmitting.value = true;

	try {
		// Payment gate: the job is only created after the card is authorized.
		let quotePaymentIntentId: string | null = null;
		if (paymentRequired.value) {
			quotePaymentIntentId = await authorizePayment();
			if (!quotePaymentIntentId) return;
		}

		const basePayload = {
			estimateId: bookingStore.estimateId,
			vehicleKey: bookingStore.selectedVehicleKey,
			selectedOptions: bookingStore.selectedOptionKeys,
			consumer: {
				first_name: (detailsValues.first_name ?? '').trim(),
				last_name: detailsValues.last_name?.trim() || null,
				phone: {
					number: (detailsValues.phone?.number ?? '').replace(/\D/g, ''),
					extension: detailsValues.phone?.extension?.trim() || null
				},
				email: (detailsValues.email ?? '').trim() || null,
				address: buildAddressPayload(
					detailsValues.address as Record<string, unknown>
				)
			},
			store_consumer_data: showStoreConsumerDataConsent.value
				? storeConsumerData.value
				: undefined,
			description: notes.value.trim() || null,
			install_time_span_id: installTimeSpanId.value ?? null,
			scheduled_date: scheduledDate.value
				? toDateString(scheduledDate.value)
				: null,
			paymentIntentId: quotePaymentIntentId
		};
		const payload: CreateQuotePayload =
			bookingStore.selectedGlassOption === 'repair'
				? {
						...basePayload,
						selectedGlassOption: 'repair',
						chipCount: bookingStore.chipCount
					}
				: {
						...basePayload,
						selectedGlassOption: 'replace'
					};

		try {
			const response = await createQuote(props.apiKey, payload);
			if (response.final_redirect_url && !props.closable)
				return window.location.assign(response.final_redirect_url);

			submitted.value = true;
		} catch (error) {
			toastMessages.showError(error);
			if (quotePaymentIntentId) {
				resetPayment();
				setupPayment();
			}
		}
	} finally {
		isSubmitting.value = false;
	}
};

const loadSettings = async () => {
	settingsLoading.value = true;
	settingsError.value = false;
	try {
		const settings = await getQuickQuoteSettings(props.apiKey);
		bookingStore.applyQuoteSettings(settings);
	} catch {
		settingsError.value = true;
	} finally {
		settingsLoading.value = false;
	}
};

onMounted(async () => {
	bookingStore.startOver();
	await loadSettings();
});

onUnmounted(() => {
	cancelEstimateRequest();
	stopLoadingAnimation();
});

watch(isLoading, loading => {
	if (loading) {
		startLoadingAnimation();
		return;
	}

	loadingProgress.value = 100;
	stopLoadingAnimation();
});

watch(
	() =>
		JSON.stringify({
			first_name: detailsValues.first_name,
			last_name: detailsValues.last_name,
			phone: detailsValues.phone,
			email: detailsValues.email,
			address: detailsValues.address
		}),
	(newValue, oldValue) => {
		if (
			oldValue !== undefined &&
			newValue !== oldValue &&
			storeConsumerData.value
		) {
			storeConsumerData.value = false;
		}
	}
);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "booking-bg tw3-flex tw3-min-h-screen tw3-flex-col tw3-text-surface-900",
    style: _normalizeStyle(themeStyle.value)
  }, [
    (props.closable && (settingsLoading.value || settingsError.value))
      ? (_openBlock(), _createBlock(BookingButton, {
          key: 0,
          class: "tw3-fixed tw3-right-4 tw3-top-4 tw3-z-30",
          icon: "pi pi-times",
          label: "Close",
          size: "small",
          variant: "secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }))
      : _createCommentVNode("", true),
    (settingsLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(ProgressSpinner), {
            class: "tw3-size-14",
            strokeWidth: "3"
          }),
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "tw3-text-sm tw3-text-surface-500" }, "Loading...", -1))
        ]))
      : (settingsError.value)
        ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
            _createVNode(BookingErrorCard, {
              actionLabel: "Try again",
              bookingPhone: _unref(bookingStore).bookingPhone,
              class: "tw3-w-full tw3-max-w-2xl",
              description: "Something went wrong while loading the booking settings. Please try again in a few moments",
              eyebrow: "Booking unavailable",
              title: "We couldn't load this booking page",
              onAction: loadSettings
            }, null, 8, ["bookingPhone"])
          ]))
        : (!_unref(bookingStore).isTurned || !_unref(bookingStore).isPriceLevelExist)
          ? (_openBlock(), _createElementBlock("main", _hoisted_3, [
              _createVNode(BookingErrorCard, {
                actionLabel: "Contact shop manager",
                bookingPhone: _unref(bookingStore).bookingPhone,
                class: "tw3-w-full tw3-max-w-2xl",
                description: "Quick Quote doesn’t appear to be fully configured for this shop",
                eyebrow: "Booking unavailable",
                title: "We couldn't load this booking page",
                onAction: loadSettings
              }, null, 8, ["bookingPhone"])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("header", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "booking-logo tw3-flex tw3-size-10 tw3-shrink-0 tw3-items-center tw3-justify-center tw3-rounded-xl tw3-text-xl tw3-text-white" }, [
                      _createElementVNode("i", { class: "pi pi-car" })
                    ], -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h1", _hoisted_8, _toDisplayString(_unref(bookingStore).shopName), 1),
                      _cache[16] || (_cache[16] = _createElementVNode("p", { class: "tw3-mt-0.5 tw3-flex tw3-items-center tw3-text-xs tw3-text-surface-500" }, [
                        _createElementVNode("i", { class: "pi pi-shield-check tw3-shrink-0 tw3-text-[0.7rem]" }),
                        _createElementVNode("span", { class: "tw3-truncate" }, " Fast, transparent quotes and bookings ")
                      ], -1))
                    ])
                  ]),
                  (
							((showVehicleSearchResult.value ||
								showPhoneVerification.value ||
								isLoading.value) &&
								!submitted.value) ||
							props.closable
						)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (
								(showVehicleSearchResult.value ||
									showPhoneVerification.value ||
									isLoading.value) &&
								!submitted.value
							)
                          ? (_openBlock(), _createBlock(BookingButton, {
                              key: 0,
                              icon: "pi pi-refresh",
                              label: "Start over",
                              size: "small",
                              variant: "secondary",
                              onClick: startOver
                            }))
                          : _createCommentVNode("", true),
                        (props.closable)
                          ? (_openBlock(), _createBlock(BookingButton, {
                              key: 1,
                              icon: "pi pi-times",
                              label: "Close",
                              size: "small",
                              variant: "secondary",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("main", {
                class: _normalizeClass(["tw3-mx-auto tw3-flex tw3-w-full tw3-max-w-5xl tw3-flex-1 tw3-flex-col tw3-px-4 sm:tw3-px-6", 
					props.closable
						? 'tw3-pb-[6rem] tw3-pt-4 sm:tw3-pt-6'
						: 'tw3-pb-32 tw3-pt-8'
				])
              }, [
                (submitted.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                      _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"tw3-flex tw3-size-20 tw3-items-center tw3-justify-center tw3-rounded-full tw3-bg-primary-50 tw3-text-primary-600\" data-v-85c4076c><i class=\"pi pi-check-circle !tw3-text-5xl\" data-v-85c4076c></i></div><div class=\"tw3-max-w-md\" data-v-85c4076c><h2 class=\"tw3-text-2xl tw3-font-bold\" data-v-85c4076c>Booking confirmed</h2><p class=\"tw3-mt-2 tw3-text-surface-500\" data-v-85c4076c> Thanks! Your booking request has been received. The shop will reach out shortly to confirm the appointment. </p></div>", 2)),
                      _createVNode(BookingButton, {
                        icon: "pi pi-plus",
                        label: "Start a new booking",
                        variant: "secondary",
                        onClick: startOver
                      })
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("nav", _hoisted_11, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: step.value
                          }, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["tw3-flex tw3-size-11 tw3-items-center tw3-justify-center tw3-rounded-full tw3-border-2 tw3-text-lg tw3-transition-all", nodeClass(index)])
                              }, [
                                (currentStepIndex.value > index)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                                  : (_openBlock(), _createElementBlock("i", {
                                      key: 1,
                                      class: _normalizeClass(step.icon)
                                    }, null, 2))
                              ], 2),
                              _createElementVNode("span", {
                                class: _normalizeClass(["tw3-text-sm tw3-font-semibold tw3-transition-colors", labelClass(index)])
                              }, _toDisplayString(step.label), 3)
                            ]),
                            (index < steps.length - 1)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["tw3-mb-8 tw3-h-0.5 tw3-flex-1 tw3-rounded-full tw3-transition-colors", 
									currentStepIndex.value > index
										? 'tw3-bg-primary-500'
										: 'tw3-bg-surface-200'
								])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 64))
                      ]),
                      _withDirectives(_createElementVNode("section", _hoisted_14, [
                        (isLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              (_unref(bookingStore).selectedVehicle)
                                ? (_openBlock(), _createBlock(BookingVehicleCard, {
                                    key: 0,
                                    vehicle: _unref(bookingStore).selectedVehicle
                                  }, null, 8, ["vehicle"]))
                                : _createCommentVNode("", true),
                              _createVNode(BookingCard, { class: "tw3-flex tw3-min-h-80 tw3-flex-col tw3-items-center tw3-justify-center tw3-gap-5 tw3-px-6 tw3-py-12 tw3-text-center" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_unref(ProgressSpinner), {
                                      class: "tw3-size-14",
                                      strokeWidth: "3"
                                    }),
                                    _cache[19] || (_cache[19] = _createElementVNode("i", { class: "pi pi-car tw3-absolute tw3-text-2xl tw3-text-primary-600" }, null, -1))
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("h2", _hoisted_18, _toDisplayString(loadingMessage.value), 1),
                                    _createElementVNode("p", _hoisted_19, _toDisplayString(loadingDescription.value), 1),
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("div", {
                                        class: "booking-progress-fill tw3-h-full tw3-rounded-full tw3-transition-all",
                                        style: _normalizeStyle({ width: loadingProgress.value + '%' })
                                      }, null, 4)
                                    ]),
                                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "tw3-mt-3 tw3-flex tw3-justify-between tw3-text-xs tw3-font-medium tw3-text-surface-400" }, [
                                      _createElementVNode("span", null, "Vehicle"),
                                      _createElementVNode("span", null, "Glass"),
                                      _createElementVNode("span", null, "Vendors"),
                                      _createElementVNode("span", null, "Price")
                                    ], -1))
                                  ])
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (showPhoneVerification.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    (_unref(bookingStore).selectedVehicle)
                                      ? (_openBlock(), _createBlock(BookingVehicleCard, {
                                          key: 0,
                                          vehicle: _unref(bookingStore).selectedVehicle
                                        }, null, 8, ["vehicle"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(BookingCard, { class: "tw3-mx-auto tw3-max-w-xl tw3-p-6" }, {
                                      default: _withCtx(() => [
                                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "tw3-flex tw3-items-start tw3-gap-4" }, [
                                          _createElementVNode("div", { class: "tw3-flex tw3-size-11 tw3-shrink-0 tw3-items-center tw3-justify-center tw3-rounded-xl tw3-bg-primary-50 tw3-text-xl tw3-text-primary-600" }, [
                                            _createElementVNode("i", { class: "pi pi-mobile" })
                                          ]),
                                          _createElementVNode("div", { class: "tw3-min-w-0" }, [
                                            _createElementVNode("h2", { class: "tw3-text-xl tw3-font-bold" }, " Verify your phone "),
                                            _createElementVNode("p", { class: "tw3-mt-1 tw3-text-sm tw3-text-surface-500" }, " Enter your phone number to receive a 6-digit verification code before we build your estimate. ")
                                          ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_22, [
                                          (phoneVerificationStage.value === 'phone')
                                            ? (_openBlock(), _createElementBlock("label", _hoisted_23, [
                                                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "tw3-text-sm tw3-font-semibold tw3-text-surface-700" }, " Phone number ", -1)),
                                                _createVNode(_unref(InputMask), {
                                                  modelValue: verificationPhone.value,
                                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((verificationPhone).value = $event)),
                                                  autocomplete: "tel",
                                                  fluid: "",
                                                  mask: "(999) 999-9999",
                                                  placeholder: "(555) 555-5555",
                                                  type: "text"
                                                }, null, 8, ["modelValue"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("label", _hoisted_24, [
                                                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "tw3-text-sm tw3-font-semibold tw3-text-surface-700" }, " 6-digit verification code ", -1)),
                                                _createVNode(_unref(InputOtp), {
                                                  modelValue: verificationCode.value,
                                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((verificationCode).value = $event)),
                                                  class: "tw3-justify-center",
                                                  integerOnly: "",
                                                  invalid: !!verificationError.value,
                                                  length: 6
                                                }, null, 8, ["modelValue", "invalid"]),
                                                _createElementVNode("div", _hoisted_25, [
                                                  _createElementVNode("span", _hoisted_26, _toDisplayString(normalizedVerificationCode.value.length) + "/6 digits ", 1),
                                                  _createElementVNode("button", {
                                                    class: "tw3-border-0 tw3-bg-transparent tw3-p-0 tw3-text-xs tw3-font-semibold tw3-text-primary-600",
                                                    type: "button",
                                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (phoneVerificationStage.value = 'phone'))
                                                  }, " Change phone ")
                                                ])
                                              ])),
                                          (verificationError.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(verificationError.value), 1))
                                            : _createCommentVNode("", true),
                                          (phoneVerificationStage.value === 'phone')
                                            ? (_openBlock(), _createBlock(BookingButton, {
                                                key: 3,
                                                disabled: !canConfirmPhone.value,
                                                icon: "pi pi-send",
                                                iconPos: "right",
                                                label: "Send code",
                                                loading: phoneConfirmationLoading.value,
                                                onClick: submitVerificationPhone
                                              }, null, 8, ["disabled", "loading"]))
                                            : (_openBlock(), _createBlock(BookingButton, {
                                                key: 4,
                                                disabled: !canVerifyCode.value,
                                                icon: "pi pi-check",
                                                iconPos: "right",
                                                label: "Verify and get estimate",
                                                loading: isLoading.value,
                                                onClick: submitVerificationCode
                                              }, null, 8, ["disabled", "loading"]))
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (showVehicleSearchResult.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      (_unref(bookingStore).selectedVehicle)
                                        ? (_openBlock(), _createBlock(BookingVehicleCard, {
                                            key: 0,
                                            vehicle: _unref(bookingStore).selectedVehicle
                                          }, null, 8, ["vehicle"]))
                                        : (vehicles.value.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                              _cache[24] || (_cache[24] = _createElementVNode("div", null, [
                                                _createElementVNode("h2", { class: "tw3-text-lg tw3-font-semibold" }, " Select your vehicle "),
                                                _createElementVNode("p", { class: "tw3-mt-0.5 tw3-text-sm tw3-text-surface-500" }, " We found a few matches — pick the one that fits ")
                                              ], -1)),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vehicles.value, (vehicle) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: vehicle.key,
                                                  class: "tw3-cursor-pointer tw3-rounded-2xl tw3-transition-all hover:-tw3-translate-y-0.5 hover:tw3-shadow-lg",
                                                  onClick: ($event: any) => (chooseVehicle(vehicle))
                                                }, [
                                                  _createVNode(BookingVehicleCard, { vehicle: vehicle }, null, 8, ["vehicle"])
                                                ], 8, _hoisted_30))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createBlock(BookingErrorCard, {
                                              key: 2,
                                              actionLabel: "Try another search",
                                              bookingPhone: _unref(bookingStore).bookingPhone,
                                              description: vehicleSearchContent.value.description,
                                              eyebrow: "Vehicle lookup",
                                              hint: vehicleSearchContent.value.hint,
                                              title: vehicleSearchContent.value.title,
                                              onAction: startOver
                                            }, null, 8, ["bookingPhone", "description", "hint", "title"]))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, [
                                        _cache[25] || (_cache[25] = _createElementVNode("h2", { class: "tw3-text-2xl tw3-font-bold" }, "Find your vehicle", -1)),
                                        _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(bookingStore).phoneVerificationRequired
												? 'Enter either the VIN or the license plate to start a secure quote with phone verification'
												: 'Enter either the VIN or the license plate to get an instant quote. You only need one'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_34, [
                                        _createVNode(BookingCard, { class: "tw3-flex tw3-flex-col tw3-gap-5 tw3-p-6" }, {
                                          default: _withCtx(() => [
                                            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "tw3-flex tw3-items-center tw3-gap-3" }, [
                                              _createElementVNode("div", { class: "tw3-flex tw3-size-10 tw3-items-center tw3-justify-center tw3-rounded-xl tw3-bg-primary-50 tw3-text-lg tw3-text-primary-600" }, [
                                                _createElementVNode("i", { class: "pi pi-hashtag" })
                                              ]),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("h3", { class: "tw3-font-semibold" }, "Enter VIN"),
                                                _createElementVNode("p", { class: "tw3-text-xs tw3-text-surface-500" }, " 17-character vehicle ID ")
                                              ])
                                            ], -1)),
                                            _createVNode(VinDecoder, { onSubmit: onVinSubmit })
                                          ]),
                                          _: 1
                                        }),
                                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "tw3-flex tw3-items-center tw3-justify-center" }, [
                                          _createElementVNode("span", { class: "tw3-flex tw3-size-9 tw3-items-center tw3-justify-center tw3-rounded-full tw3-border tw3-border-surface-200 tw3-bg-surface-0 tw3-text-xs tw3-font-bold tw3-uppercase tw3-text-surface-400" }, " or ")
                                        ], -1)),
                                        _createVNode(BookingCard, { class: "tw3-flex tw3-flex-col tw3-gap-5 tw3-p-6" }, {
                                          default: _withCtx(() => [
                                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "tw3-flex tw3-items-center tw3-gap-3" }, [
                                              _createElementVNode("div", { class: "tw3-flex tw3-size-10 tw3-items-center tw3-justify-center tw3-rounded-xl tw3-bg-primary-50 tw3-text-lg tw3-text-primary-600" }, [
                                                _createElementVNode("i", { class: "pi pi-id-card" })
                                              ]),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("h3", { class: "tw3-font-semibold" }, "Enter license plate"),
                                                _createElementVNode("p", { class: "tw3-text-xs tw3-text-surface-500" }, " Plate number and state ")
                                              ])
                                            ], -1)),
                                            _createVNode(PlateDecoder, { onSubmit: onPlateSubmit })
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])),
                              (pricingReady.value)
                                ? (_openBlock(), _createBlock(BookingCard, {
                                    key: 3,
                                    class: "tw3-p-6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(BookingCardHeader, {
                                        subtitle: "Tap to add services. Your total updates instantly.",
                                        title: "Glass & options"
                                      }),
                                      _createVNode(BookingItemPricing)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                      ], 512), [
                        [_vShow, activeStep.value === 1]
                      ]),
                      _withDirectives(_createElementVNode("section", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(BookingCard, { class: "tw3-p-6" }, {
                            default: _withCtx(() => [
                              _createVNode(BookingCardHeader, {
                                icon: "pi pi-user",
                                subtitle: "We will use this to confirm the appointment.",
                                title: "Contact information"
                              }),
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(BookingField, {
                                  modelValue: _unref(firstName),
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(firstName) ? (firstName).value = $event : null)),
                                  autocomplete: "given-name",
                                  error: _unref(errors)['first_name'],
                                  label: "First name",
                                  placeholder: "First name"
                                }, null, 8, ["modelValue", "error"]),
                                _createVNode(BookingField, {
                                  modelValue: _unref(lastName),
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(lastName) ? (lastName).value = $event : null)),
                                  autocomplete: "family-name",
                                  label: "Last name",
                                  placeholder: "Last name"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("label", _hoisted_38, [
                                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "tw3-text-sm tw3-font-semibold tw3-text-surface-700" }, " Phone ", -1)),
                                  _createElementVNode("div", _hoisted_39, [
                                    _withDirectives(_createVNode(_unref(InputMask), {
                                      modelValue: _unref(phoneNumber),
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(phoneNumber) ? (phoneNumber).value = $event : null)),
                                      autocomplete: "tel",
                                      class: "tw3-flex-1",
                                      disabled: !!verifiedPhoneNumber.value,
                                      fluid: "",
                                      invalid: !!_unref(errors)['phone.number'],
                                      mask: "(999) 999-9999",
                                      placeholder: "Phone",
                                      type: "text"
                                    }, null, 8, ["modelValue", "disabled", "invalid"]), [
                                      [
                                        _directive_tooltip,
                                        {
													value: _unref(errors)['phone.number'],
													pt: {
														text: {
															style: { backgroundColor: 'rgb(248 113 113)' }
														},
														arrow: {
															style: { borderTopColor: 'rgb(248 113 113)' }
														}
													}
												},
                                        void 0,
                                        { top: true }
                                      ]
                                    ]),
                                    _createVNode(_unref(InputText), {
                                      modelValue: _unref(phoneExtension),
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(phoneExtension) ? (phoneExtension).value = $event : null)),
                                      class: "tw3-w-24",
                                      disabled: !!verifiedPhoneNumber.value,
                                      maxlength: "8",
                                      placeholder: "Ext",
                                      type: "text"
                                    }, null, 8, ["modelValue", "disabled"])
                                  ])
                                ]),
                                _createElementVNode("label", _hoisted_40, [
                                  _cache[30] || (_cache[30] = _createElementVNode("span", { class: "tw3-text-sm tw3-font-semibold tw3-text-surface-700" }, " Email ", -1)),
                                  _createVNode(_unref(InputTextWithError), {
                                    modelValue: _unref(email),
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                                    class: "tw3-w-full",
                                    errMsg: _unref(errors)['email'],
                                    placeholder: "name@example.com",
                                    type: "email"
                                  }, null, 8, ["modelValue", "errMsg"])
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(BookingCard, { class: "tw3-p-6" }, {
                            default: _withCtx(() => [
                              _createVNode(BookingCardHeader, {
                                icon: "pi pi-map-marker",
                                subtitle: "Tell us where and when the service should happen.",
                                title: "Service details"
                              }),
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("label", _hoisted_42, [
                                  _cache[31] || (_cache[31] = _createElementVNode("span", { class: "tw3-text-sm tw3-font-semibold tw3-text-surface-700" }, " Service address ", -1)),
                                  _createVNode(InputAddress, {
                                    errMsg: addressError.value,
                                    modelValue: _unref(address) as Partial<Address>,
                                    withExtra: "",
                                    withPoBox: "",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = value => (address.value = value))
                                  }, null, 8, ["errMsg", "modelValue"])
                                ]),
                                _createElementVNode("label", _hoisted_43, [
                                  _cache[32] || (_cache[32] = _createElementVNode("span", { class: "tw3-text-sm tw3-font-semibold tw3-text-surface-700" }, " Preferred date ", -1)),
                                  _createVNode(_unref(DatePicker), {
                                    modelValue: scheduledDate.value,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((scheduledDate).value = $event)),
                                    dateFormat: "mm/dd/yy",
                                    disabledDates: disabledDates.value,
                                    disabledDays: disabledDays.value,
                                    fluid: "",
                                    minDate: new Date(),
                                    placeholder: "Select a date",
                                    showIcon: ""
                                  }, {
                                    date: _withCtx(({ date }) => [
                                      (holidayForCell(date))
                                        ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            style: _normalizeStyle(holidayCellStyle(holidayForCell(date)!))
                                          }, [
                                            _createTextVNode(_toDisplayString(date.day) + " ", 1),
                                            _createElementVNode("span", {
                                              style: _normalizeStyle(holidayDotStyle(holidayForCell(date)!))
                                            }, null, 4)
                                          ], 4)), [
                                            [
                                              _directive_tooltip,
                                              holidayForCell(date)!.name,
                                              void 0,
                                              { top: true }
                                            ]
                                          ])
                                        : (closedWeekday(date) !== undefined)
                                          ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                              key: 1,
                                              style: closedCellStyle
                                            }, [
                                              _createTextVNode(_toDisplayString(date.day), 1)
                                            ])), [
                                              [
                                                _directive_tooltip,
                                                
														closedWeekdayLabel(closedWeekday(date)!)
													,
                                                void 0,
                                                { top: true }
                                              ]
                                            ])
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              _createTextVNode(_toDisplayString(date.day), 1)
                                            ], 64))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabledDates", "disabledDays", "minDate"])
                                ]),
                                _createElementVNode("label", _hoisted_44, [
                                  _cache[33] || (_cache[33] = _createElementVNode("span", { class: "tw3-text-sm tw3-font-semibold tw3-text-surface-700" }, " Installation time window ", -1)),
                                  (timeSpanOptions.value.length)
                                    ? (_openBlock(), _createBlock(_unref(Select), {
                                        key: 0,
                                        modelValue: installTimeSpanId.value,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((installTimeSpanId).value = $event)),
                                        optionLabel: "label",
                                        options: timeSpanOptions.value,
                                        optionValue: "id",
                                        placeholder: "Select a time window",
                                        showClear: ""
                                      }, null, 8, ["modelValue", "options"]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_45, " No specific time windows are configured. The shop will coordinate a time with you directly "))
                                ]),
                                _createVNode(BookingField, {
                                  modelValue: notes.value,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((notes).value = $event)),
                                  label: "Notes",
                                  placeholder: "Gate code, parking notes, glass damage details...",
                                  rows: 4,
                                  type: "textarea"
                                }, null, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          }),
                          (showStoreConsumerDataConsent.value)
                            ? (_openBlock(), _createBlock(BookingCard, {
                                key: 0,
                                class: "tw3-p-6"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("label", _hoisted_46, [
                                    _createVNode(_unref(Checkbox), {
                                      modelValue: storeConsumerData.value,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((storeConsumerData).value = $event)),
                                      binary: "",
                                      inputId: "storeConsumerData"
                                    }, null, 8, ["modelValue"]),
                                    _cache[34] || (_cache[34] = _createElementVNode("span", { class: "tw3-grid tw3-gap-1" }, [
                                      _createElementVNode("span", { class: "tw3-text-sm tw3-font-semibold tw3-text-surface-800" }, " Save my personal details for future use "),
                                      _createElementVNode("span", { class: "tw3-text-sm tw3-text-surface-500" }, " Allow this shop to securely save your contact and address information so future bookings can be faster. ")
                                    ], -1))
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("aside", _hoisted_47, [
                          _createVNode(BookingQuoteSummary)
                        ])
                      ], 512), [
                        [_vShow, activeStep.value === 2]
                      ]),
                      _withDirectives(_createElementVNode("section", _hoisted_48, [
                        (paymentStepLoading.value)
                          ? (_openBlock(), _createBlock(BookingCard, {
                              key: 0,
                              class: "tw3-flex tw3-min-h-80 tw3-flex-col tw3-items-center tw3-justify-center tw3-gap-5 tw3-px-6 tw3-py-12 tw3-text-center lg:tw3-col-span-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_49, [
                                  _createVNode(_unref(ProgressSpinner), {
                                    class: "tw3-size-14",
                                    strokeWidth: "3"
                                  }),
                                  _cache[35] || (_cache[35] = _createElementVNode("i", { class: "pi pi-credit-card tw3-absolute tw3-text-2xl tw3-text-primary-600" }, null, -1))
                                ]),
                                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "tw3-max-w-md" }, [
                                  _createElementVNode("h2", { class: "tw3-text-lg tw3-font-semibold" }, " Preparing secure payment... "),
                                  _createElementVNode("p", { class: "tw3-mt-1 tw3-text-sm tw3-text-surface-500" }, " Connecting to Stripe. This only takes a moment ")
                                ], -1))
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_50, [
                                (paymentRequired.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (stripeLoadError.value || paymentSetupError.value)
                                        ? (_openBlock(), _createBlock(BookingCard, {
                                            key: 0,
                                            class: "tw3-flex tw3-min-h-80 tw3-flex-col tw3-items-center tw3-justify-center tw3-gap-3 tw3-p-6 tw3-text-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("p", _hoisted_51, _toDisplayString(paymentSetupError.value ||
												'We could not load the payment form. This is sometimes caused by browser extensions — try disabling them or use a different browser.'), 1),
                                              _createVNode(BookingButton, {
                                                icon: "pi pi-refresh",
                                                label: "Try again",
                                                size: "small",
                                                variant: "secondary",
                                                onClick: setupPayment
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        ref_key: "paymentElementContainer",
                                        ref: paymentElementContainer
                                      }, null, 512)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createVNode(BookingCard, { class: "tw3-p-6" }, {
                                  default: _withCtx(() => [
                                    _cache[43] || (_cache[43] = _createElementVNode("h3", { class: "tw3-mb-4 tw3-text-base tw3-font-semibold" }, " Review your booking ", -1)),
                                    _createElementVNode("dl", _hoisted_52, [
                                      _createElementVNode("div", _hoisted_53, [
                                        _cache[37] || (_cache[37] = _createElementVNode("dt", { class: "tw3-text-sm tw3-text-surface-500" }, "Vehicle", -1)),
                                        _createElementVNode("dd", _hoisted_54, _toDisplayString(vehicleLabel.value || selectedVehicle.value?.vin || '—'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_55, [
                                        _cache[38] || (_cache[38] = _createElementVNode("dt", { class: "tw3-text-sm tw3-text-surface-500" }, " Service address ", -1)),
                                        _createElementVNode("dd", _hoisted_56, _toDisplayString(_unref(address)?.full_address || '—'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_57, [
                                        _cache[39] || (_cache[39] = _createElementVNode("dt", { class: "tw3-text-sm tw3-text-surface-500" }, " Preferred date ", -1)),
                                        _createElementVNode("dd", _hoisted_58, _toDisplayString(scheduledDate.value ? toDateString(scheduledDate.value) : '—'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_59, [
                                        _cache[40] || (_cache[40] = _createElementVNode("dt", { class: "tw3-text-sm tw3-text-surface-500" }, "Contact", -1)),
                                        _createElementVNode("dd", _hoisted_60, _toDisplayString(_unref(firstName)) + " " + _toDisplayString(_unref(lastName)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_61, [
                                        _cache[41] || (_cache[41] = _createElementVNode("dt", { class: "tw3-text-sm tw3-text-surface-500" }, "Phone", -1)),
                                        _createElementVNode("dd", _hoisted_62, _toDisplayString(_unref(phoneNumber) || '—'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_63, [
                                        _cache[42] || (_cache[42] = _createElementVNode("dt", { class: "tw3-text-sm tw3-text-surface-500" }, "Email", -1)),
                                        _createElementVNode("dd", _hoisted_64, _toDisplayString(_unref(email) || '—'), 1)
                                      ]),
                                      (paymentRequired.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                            _createElementVNode("dt", _hoisted_66, " Due today " + _toDisplayString(_unref(bookingStore).dueTodayPercent), 1),
                                            _createElementVNode("dd", _hoisted_67, _toDisplayString(_unref(formatMoney)(_unref(bookingStore).prepaymentAmount || 0)), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("aside", _hoisted_68, [
                                _createVNode(BookingQuoteSummary)
                              ])
                            ], 64))
                      ], 512), [
                        [_vShow, activeStep.value === 3]
                      ])
                    ], 64))
              ], 2),
              (!submitted.value && !isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(BookingButton, {
                        disabled: !canGoBack.value,
                        icon: "pi pi-arrow-left",
                        label: "Back",
                        variant: "text",
                        onClick: goBack
                      }, null, 8, ["disabled"]),
                      (hasQuote.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            _createElementVNode("div", _hoisted_72, [
                              _cache[44] || (_cache[44] = _createElementVNode("span", { class: "tw3-text-xs tw3-text-surface-500" }, "Total", -1)),
                              _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(formatMoney)(quoteTotal.value as number)), 1)
                            ]),
                            (paymentRequired.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                  _cache[45] || (_cache[45] = _createElementVNode("span", { class: "tw3-text-xs tw3-text-surface-500" }, "Due today", -1)),
                                  _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(formatMoney)(_unref(bookingStore).prepaymentAmount || 0)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (activeStep.value === 1)
                        ? (_openBlock(), _createBlock(BookingButton, {
                            key: 1,
                            disabled: !canContinueFromVehicle.value,
                            icon: "pi pi-arrow-right",
                            iconPos: "right",
                            label: "Continue",
                            onClick: goNext
                          }, null, 8, ["disabled"]))
                        : (activeStep.value === 2)
                          ? (_openBlock(), _createBlock(BookingButton, {
                              key: 2,
                              disabled: !canContinueFromDetails.value,
                              icon: "pi pi-arrow-right",
                              iconPos: "right",
                              label: "Continue",
                              onClick: continueFromDetails
                            }, null, 8, ["disabled"]))
                          : (_openBlock(), _createBlock(BookingButton, {
                              key: 3,
                              icon: "pi pi-check",
                              iconPos: "right",
                              label: "Confirm booking",
                              loading: isSubmitting.value,
                              onClick: submitBooking
                            }, null, 8, ["loading"]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("a", {
                class: _normalizeClass(["tw3-fixed tw3-right-4 tw3-z-10 tw3-flex tw3-items-center tw3-gap-2 tw3-text-[0.65rem] tw3-font-semibold tw3-uppercase tw3-tracking-wide tw3-text-surface-400 tw3-opacity-80 tw3-transition-opacity hover:tw3-opacity-100", submitted.value ? 'tw3-bottom-4' : 'tw3-bottom-20']),
                href: "https://glassbiller.com",
                rel: "noopener noreferrer",
                target: "_blank"
              }, _cache[46] || (_cache[46] = [
                _createElementVNode("span", null, "Powered by", -1),
                _createElementVNode("img", {
                  alt: "GlassBiller",
                  class: "tw3-h-auto tw3-w-24",
                  height: "40",
                  src: "https://web-form.glassbiller.com/img/glassbiller-logo.png",
                  width: "213"
                }, null, -1)
              ]), 2)
            ], 64))
  ], 4))
}
}

})